import type { PolkadotClient } from 'polkadot-api'
import type { SupportedChain } from '~/plugins/sdk.client'
import { PROVIDERS } from '~/config/providers'

export const useRpcProviderStore = defineStore('rpcProvider', () => {
  const selectedProviders = ref<Partial<Record<SupportedChain, string>>>({})
  /** Last measured latency (ms) per chain for the current provider; used for Connection pill tooltip. */
  const lastLatencyByChain = ref<Partial<Record<SupportedChain, number | null>>>({})

  function getProvider(chain: SupportedChain): string {
    return selectedProviders.value[chain] || PROVIDERS[chain][0]
  }

  function setProvider(chain: SupportedChain, url: string) {
    if (selectedProviders.value[chain] === url) {
      return
    }

    selectedProviders.value[chain] = url

    // Destroy existing client so it gets recreated with the new endpoint
    const clients = useState<Partial<Record<SupportedChain, PolkadotClient>>>('sdk-clients')
    const existingClient = clients.value[chain]
    if (existingClient) {
      existingClient.destroy()
      delete clients.value[chain]
    }
  }

  function setLastLatency(chain: SupportedChain, latency: number | null) {
    lastLatencyByChain.value[chain] = latency
  }

  return {
    selectedProviders,
    lastLatencyByChain,
    getProvider,
    setProvider,
    setLastLatency,
  }
}, {
  persist: {
    pick: ['selectedProviders'],
  },
})
